// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Promise = require("@rescript/core/src/Core__Promise.bs.js");
var StripeJs = require("@stripe/stripe-js");
var ReactStripeJs = require("@stripe/react-stripe-js");

function fromJs(obj) {
  var match = obj.brand;
  var tmp;
  switch (match) {
    case "American Express" :
        tmp = "AmericanExpress";
        break;
    case "Discover" :
        tmp = "Discover";
        break;
    case "MasterCard" :
        tmp = "MasterCard";
        break;
    case "Visa" :
        tmp = "Visa";
        break;
    default:
      tmp = "Unknown";
  }
  return {
          expMonth: obj.exp_month,
          expYear: obj.exp_year,
          brand: tmp,
          last4: obj.last4,
          name: obj.name
        };
}

function fromJs$1(obj) {
  return {
          id: obj.id,
          card: fromJs(obj.card)
        };
}

function getCardElement(t, elementType) {
  return t.getElement(elementType);
}

function useElements() {
  return Caml_option.nullable_to_opt(ReactStripeJs.useElements());
}

function useStripe() {
  return Caml_option.nullable_to_opt(ReactStripeJs.useStripe());
}

function createToken(apiInstance, cardElement, data) {
  return Core__Promise.$$catch(apiInstance.createToken(cardElement, data).then(function (response) {
                  var match = response.token;
                  var match$1 = response.error;
                  if (match == null) {
                    if (match$1 == null) {
                      return {
                              TAG: "Error",
                              _0: {
                                code: "no code",
                                message: "no message",
                                type: "no type"
                              }
                            };
                    } else {
                      return {
                              TAG: "Error",
                              _0: match$1
                            };
                    }
                  } else {
                    return {
                            TAG: "Ok",
                            _0: fromJs$1(match)
                          };
                  }
                }), (function (param) {
                return Promise.resolve({
                            TAG: "Error",
                            _0: {
                              code: "no code",
                              message: "no message",
                              type: "no type"
                            }
                          });
              }));
}

var API = {
  createToken: createToken
};

function loadStripe(prim) {
  return StripeJs.loadStripe(prim);
}

var Card = {};

var Token = {};

var React_Elements = {
  getCardElement: getCardElement,
  make: ReactStripeJs.Elements
};

var React = {
  Elements: React_Elements,
  useElements: useElements,
  useStripe: useStripe
};

exports.loadStripe = loadStripe;
exports.Card = Card;
exports.Token = Token;
exports.React = React;
exports.API = API;
/* React Not a pure module */
